// Body for the edge retrieve call made when the user comes back from a Trinsic
// provider (Czech Bank iD, MojeID, BankID SE/NO, FTN) to
// /<provider>/return?sessionId=...&resultsAccessKey=...
//
// dcams-idmax-retrieve only calls IDResponse /process/continue when `code` is
// present, and for Trinsic it uses `code` as the template's access_key. The
// legacy (non-edge) branch already forwards resultsAccessKey; without it in
// edge mode the bank login completes but the verification never does.
export const buildEdgeTrinsicRetrieveBody = ({
  storedRequestId,
  settingsRequestId,
  sessionId,
  resultsAccessKey,
}) => {
  const body = {
    request_id: storedRequestId || settingsRequestId,
    sessionId,
    trinsic: true,
  };
  if (typeof resultsAccessKey === "string" && resultsAccessKey.trim() !== "") {
    body.code = resultsAccessKey.trim();
  }
  return body;
};

// Same body with the access key masked, for console logging.
export const redactRetrieveBody = (body) =>
  body && body.code ? { ...body, code: "[redacted]" } : body;

// The Trinsic return is edge when the journey said so (data.edge), when this tab
// saved the edge request_id before the redirect, or when the return URL itself
// carries ?edge=true. The last case is Bank iD's QR flow: the user finishes on
// another device, so this tab has neither data nor sessionStorage.
export const isEdgeTrinsicReturn = ({ dataEdge, storedRequestId, edgeParam }) =>
  dataEdge === true || !!storedRequestId || edgeParam === "true";

// Lookup-only body (no `code`): retrieve resolves the Trinsic sessionId to the
// session's request_id without calling /process/continue.
export const buildEdgeTrinsicLookupBody = (sessionId) => ({ sessionId, trinsic: true });
